export const maxDashboardWidth = 1200
export const maxVerticalCardWidth = 350
export const maxHorizontalCardWidth = 730
export const maxDynamicYieldCardWidth = 612
export const minDynamicYieldCardHeight = 142
export const maxDynamicYieldWrapperWidth = 1260
export const maxModalWidth = 650
